import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './Hero.css';
import banner1 from '../../assets/Banner/Banner-1.jpg';
import banner2 from '../../assets/Banner/Banner-2.jpg';
import banner3 from '../../assets/Banner/Banner-3.jpg';
// Import your logo image
import vpsLogo from '../../assets/Logo/vps infrastructure logo.png'; // Update with your actual path

const Hero = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const carouselElement = document.getElementById('heroCarousel');
    
    const handleSlide = (event) => {
      setActiveIndex(event.to);
    };

    carouselElement.addEventListener('slide.bs.carousel', handleSlide);
    return () => carouselElement.removeEventListener('slide.bs.carousel', handleSlide);
  }, []);

  const slides = [
    {
      img: banner1,
      tag: "VPS INFRASTRUCTURE | Construction & Roofing Solutions in Tamil Nadu",
      title: "CRAFTING MODERN RESIDENTIAL SPACES",
      desc: "Delivering excellence in residential building development."
    },
    {
      img: banner2,
      tag: "COMMERCIAL DEVELOPMENT",
      title: "SHAPING MODERN COMMERCIAL SPACES",
      desc: "Delivering excellence in commercial building development."
    },
    {
      img: banner3,
      tag: "INTERIOR EXCELLENCE",
      title: "DESIGNING COMFORT WITH STYLE",
      desc: "Creating inspiring interiors that blend elegance and functionality."
    }
  ];

  return (
    <div id="heroCarousel" className="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-interval="5000">
      <div className="carousel-inner">
        {slides.map((slide, index) => (
          <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`} style={{ backgroundImage: `url(${slide.img})` }}>
            <div className="overlay"></div>
            <div className="container h-100">
              <div className="row h-100 align-items-center">
                {/* Left Content */}
                <div className="col-lg-7">
                  <div className="hero-content text-white">
                    <span className="text-warning fw-bold mb-2 d-block">● {slide.tag}</span>
                    <h1 className="display-3 fw-bold">{slide.title}</h1>
                    <p className="lead mb-4">{slide.desc}</p>
                  </div>
                </div>

                {/* Right Circle Design with Logo */}
                <div className="col-lg-5 d-none d-lg-flex justify-content-center">
  <div className="hero-circle-wrapper">
    <div className="outer-ring"></div>
    <div className="inner-circle">
      {/* Fixed: Width and Height are controlled by the parent container */}
      <img src={vpsLogo} alt="VPS Logo" className="circle-img-logo" />
    </div>
  </div>
</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Indicators & Controls */}
      <div className="hero-controls-container">
        <div className="hero-indicators-lines d-none d-md-flex">
          {slides.map((_, idx) => (
            <span 
              key={idx}
              className={`line ${activeIndex === idx ? 'active' : ''}`} 
              data-bs-target="#heroCarousel" 
              data-bs-slide-to={idx}
            ></span>
          ))}
        </div>

        <div className="hero-arrow-group">
          <button className="custom-arrow prev" type="button" data-bs-target="#heroCarousel" data-bs-slide="prev">
            <i className="bi bi-arrow-left"></i>
          </button>
          <button className="custom-arrow next" type="button" data-bs-target="#heroCarousel" data-bs-slide="next">
            <i className="bi bi-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hero;